<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-tittle">Praise for <i>A Dangerous Woman</i></p>
<p class="fm-01">“Original and beautifully written … Somehow, the author has managed to inhabit Martha so completely and bring her to life on the page so vividly that we lose our own sense of how ‘different’ she is. I’d call this a heartbreaking novel, except there’s a certain triumph in it, so I’ll just say that it’s a wonderful novel, and that it will absolutely transport you.”</p>
<p class="fm-13">—<i>Cosmopolitan</i></p>
<p class="fm-01">“Brilliantly acute … Remarkable … Morris’s magnanimous ability to portray her characters with so much tenderness and cruelty may be her novel’s finest strength.”</p>
<p class="fm-13">—<i>The Boston Sunday Globe</i></p>
<p class="fm-01">“Martha Horgan is at once the most irritating and engaging character to inhabit a novel in a long time.… Morris has shown us that those who live outside the magic circle of friendship and family have a rich inner life like the rest of us, only much sadder and unforgettable.”</p>
<p class="fm-13">—<i>Time</i></p>
<p class="fm-01">“Morris has created a remarkable portrait of a disturbed woman who is a fully sexual creature.”</p>
<p class="fm-13">—<i>The Washington Post</i></p>
<p class="fm-01">“Morris has given us a small town American tragedy that Dreiser would have recognized and found very real. She brings to American fiction a realism that has been absent far too much and for far too long.”</p>
<p class="fm-13">—<i>Newark Star Ledger</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?845baf4e